import { render, staticRenderFns } from "./MainContainer.vue?vue&type=template&id=03ebb270&scoped=true"
import script from "./MainContainer.vue?vue&type=script&lang=js"
export * from "./MainContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03ebb270",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('03ebb270')) {
      api.createRecord('03ebb270', component.options)
    } else {
      api.reload('03ebb270', component.options)
    }
    module.hot.accept("./MainContainer.vue?vue&type=template&id=03ebb270&scoped=true", function () {
      api.rerender('03ebb270', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/MainContainer.vue"
export default component.exports